import React, {FC} from "react";
import {TFetchedNewsDto} from "../../types/contracts";
import {MdOutlineDelete} from "react-icons/md";
import {CiEdit} from "react-icons/ci";
import {useModal} from "../../hooks/useModal";
import {NewsFormComponentModal} from "../admin/NewsFormComponentModal";

interface NewsFormComponentProps {
    news: TFetchedNewsDto[];
    handleNewsChange: (index: number, event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    removeNews: (index: number) => void;
    addNews: () => void;
}

export const NewsFormComponent: FC<NewsFormComponentProps> = ({ news, handleNewsChange, removeNews, addNews }) => {
    const {isOpen: isModalOpen, openModal, closeModal} = useModal();

    return (
        <div className="mb-6">
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                Aktuality
                <CiEdit
                    onClick={openModal}
                    className="text-2xl cursor-pointer text-gray-600 hover:text-gray-800"
                />
            </h3>
            {Array.isArray(news) && news.map((latestNew, index) => (
                latestNew.body ? (
                    <div
                        key={index}
                        className="flex justify-between mb-6 bg-gray-100 p-3 rounded-lg"
                    >
                        <div className="flex flex-col w-[95%]">
                            <p className="flex items-center gap-2">
                                Titulek aktuality: {latestNew.headline}
                            </p>
                            <p className="flex items-center gap-2">
                                Obsah aktuality: {latestNew.body}
                            </p>
                        </div>
                        <MdOutlineDelete
                            onClick={() => removeNews(index)}
                            className="text-red-500 rounded-md size-6 cursor-pointer ml-4"
                        />
                    </div>
                ) : null
            ))}
            <NewsFormComponentModal
                open={isModalOpen}
                onClose={closeModal}
                news={news || []}
                handleNewsChange={handleNewsChange}
                removeNews={removeNews}
                addNews={addNews}
            />
        </div>
    );
};